import React, { useEffect, useState } from "react";

//CSS
import "./employeeCard.css";

//Components
import Button from "../Other Components/button";

import { motion } from "framer-motion";
import { fadeIn, hoverEffect } from "../Other Components/animations";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import SvgClientIcon from "../../SvgIcons/ClientIcon";

//Functions and hooks
import { GetStorageLink } from "../../BackendAccess/FrontendHelpers";
import { useTranslation } from "react-i18next";

export default function EmployeeCard({ UserData, className = "", onClick }) {
  const isNarrow = useNarrowMode();

  const itemCardClassName = className + " employee-card ";

  const [preview, setPreview] = useState(null);

  const localWarehouses =
    UserData.Warehouses.length > 0 ? UserData.Warehouses.join(", ") : "none";

  const { t } = useTranslation();

  useEffect(() => {
    setPreview(
      UserData.ImagePath ? GetStorageLink() + UserData.ImagePath : null
    );
  }, [UserData.ImagePath]);

  const previewImage = preview ? (
    <img
      src={preview}
      alt="No image."
      className="employee-card-image z-inherit"
    />
  ) : (
    <SvgClientIcon className="employee-card-image empty" />
  );

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      key={UserData.UserID}
      variants={fadeIn(0.2)}
      className={itemCardClassName}
    >
      <div className="employee-card-footer">
        <span className="employee-card-ID">
          {t("Username") + ":"}{" "}
          <span className="textcolor-span">{UserData.Username}</span>
        </span>
        <span className="employee-card-ID">
          {t("ID") + ":"}{" "}
          <span className="textcolor-span">{UserData.UserID}</span>
        </span>

        <Button icon="edit" onClick={onClick}>
          {t("Edit")}
        </Button>
      </div>
      <div className="employee-card-body">
        <div className="employee-card-image-container">{previewImage}</div>
        <div className="employee-card-details">
          <span className="employee-card-detail name">
            {t("Name") + ":"}{" "}
            <span className="textcolor-span">{UserData.Name}</span>
          </span>
          <span className="employee-card-detail email">
            {t("Email") + ":"}{" "}
            <span className="textcolor-span">{UserData.Email}</span>
          </span>
          <span className="employee-card-detail role">
            {t("Role") + ": "}
            <span className="textcolor-span">
              {UserData.Role ? UserData.Role : "none"}
            </span>
          </span>
          <span className="employee-card-detail warehouses">
            {t("Warehouses allowed") + ": "}
            <span className="textcolor-span">{localWarehouses}</span>
          </span>
        </div>
      </div>
    </motion.div>
  );
}
